module.exports = __webpack_public_path__ + "static/media/logo-light.7ea78377.svg";